import React, {useEffect, useState} from "react";
import {Select, Space} from "antd";
import {useTranslation} from "react-i18next";
import AnnouncementListing_5 from "./component/announcementListing";
import {getUserAnnouncementByUserId} from "../../../../api/graphql/announcement";
import {
    globalNotificationState,
    globalUnreadAnnouncementCountState,
    globalUnreadPushNotificationCountState
} from "../../../../_common/global_state";
import {useSetRecoilState} from "recoil";
import "./css/style.css"
import {getPushNotificationLogByUserId} from "../../../../api/graphql/pushNotification";
import PushNotificationListing_5 from "./component/pushNotificationListing";

const Announcement_5 = (props) => {
    const {isHeader} = props
    const {t} = useTranslation();
    const setNotificationMessage = useSetRecoilState(globalNotificationState);
    const setUnreadAnnouncementCount = useSetRecoilState(globalUnreadAnnouncementCountState);
    const [announcementTotal, setAnnouncementTotal] = useState(0)
    const [announcementData, setAnnouncementData] = useState({});
    const [selectedCategory, setSelectedCategory] = useState("announcement")

    const userId = localStorage.getItem("userid")

    const preload = async () => {
        try {
            const responseAnnouncement = await getUserAnnouncementByUserId(userId, 8, 0);
            setAnnouncementData(responseAnnouncement?.getUserAnnouncementByUserId?.data);
            setUnreadAnnouncementCount(responseAnnouncement?.getUserAnnouncementByUserId?.unreadTotal);
            setAnnouncementTotal(responseAnnouncement?.getUserAnnouncementByUserId?.total);
        } catch (e) {
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the announcement page. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        }
    }

    useEffect(() => {
        preload()
    }, [])

    const categoryOptions = [
        {label: "Announcement", value: "announcement"},
        {label: "Push Notification", value: "pushNotification"}
    ]

    let component

    switch (selectedCategory) {
        case "announcement":
            component = <AnnouncementListing_5 isHeader={isHeader} data={announcementData} total={announcementTotal}/>
            break
        case "pushNotification":
            component = <PushNotificationListing_5 isHeader={isHeader}/>
            break
        default:
            component = <AnnouncementListing_5 isHeader={isHeader} data={announcementData} total={announcementTotal}/>
            break
    }

    return (
        <div id={"announcement"}>
            <Space>
                <Select
                    options={categoryOptions}
                    className={"dropdown-select"}
                    value={selectedCategory}
                    onChange={(value) => setSelectedCategory(value)}
                />
            </Space>
            {component}
        </div>

        // <Tabs
        //             id={"announcement"}
        //             defaultActiveKey="1"
        //             items={items}
        //         />
    );
}

export default Announcement_5